import React, { createContext, useContext, useMemo } from "react";

export type FieldSize = "sm" | "md";

const FormDensityContext = createContext<FieldSize>("md");

export function FormDensityProvider({
  value,
  children,
}: {
  value: FieldSize;
  children: React.ReactNode;
}) {
  const memo = useMemo(() => value, [value]);
  return (
    <FormDensityContext.Provider value={memo}>
      {children}
    </FormDensityContext.Provider>
  );
}

export function useFormDensity(): FieldSize {
  return useContext(FormDensityContext);
}
